'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import React from 'react';
import { render } from 'react-dom';
import * as I18n from 'I18n';
import auth from './utils/Auth';
import PortalIdParser from 'PortalIdParser';
import { debug } from './utils/env';
import { getBaseUrlForCustomers } from './utils/utils';
import ContentRoutes from 'ContentUtils/Routes'; // Configure the router

import { createHistory } from 'history';
import { Router, useRouterHistory } from 'react-router';
import routes from './Routes';
import historyAdapter from 'react-rhumb/historyAdapterV3';
import RhumbProvider from 'react-rhumb/RhumbProvider';
import rhumbConfig from '../rhumb-config.yaml'; // Configure the redux store

import 'redux';
import { Provider } from 'react-redux';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import { usageTrackerMiddleware } from 'usage-tracker-redux';
import usageActionHandlers from './lib/usage/actionHandlers';
import { getTracker, setTracker } from './lib/usage/tracker';
import appMiddleware from './middlewares/install';
import appRootReducer from './reducers';
import _configureStore from './utils/configureStore';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import 'I18n/init/data/currency';

var Application = /*#__PURE__*/function () {
  function Application(_ref) {
    var i18nProvider = _ref.i18nProvider,
        tracker = _ref.tracker;

    _classCallCheck(this, Application);

    setTracker(tracker);
    this.i18nProvider = i18nProvider;
  }

  _createClass(Application, [{
    key: "start",
    value: function start() {
      var _this = this;

      var withAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (debug()) {
        window.AppInstance = this;
      }

      var langAvailable = Promise.all([this.i18nProvider.register(lang), registerAllData(this.i18nProvider)]);
      var promises = [langAvailable];

      if (withAuth) {
        PortalIdParser.get();
        promises.push(auth.init().then(function (_ref2) {
          var user = _ref2.user,
              portal = _ref2.portal;

          _this.i18nProvider.setLocale({
            locale: user.locale,
            langEnabled: user.lang_enabled,
            timezone: portal.timezone
          });

          return langAvailable;
        }));
      }

      return Promise.all(promises).done(function () {
        _this.setSentryParams();

        _this.startReduxAndRouter(withAuth);

        _this.translatePageTitle();
      });
    }
  }, {
    key: "getGatesMap",
    value: function getGatesMap(gates) {
      return gates.reduce(function (acc, gate) {
        return Object.assign({}, acc, _defineProperty({}, gate, true));
      }, {});
    }
  }, {
    key: "setSentryParams",
    value: function setSentryParams() {
      I18n.sendSentryOnMissingTranslations = true;
      I18n.sendSentryOnMissingValues = true;
    }
  }, {
    key: "translatePageTitle",
    value: function translatePageTitle() {
      document.title = I18n.text('htmlTitle');
    }
  }, {
    key: "getUserGatesPortalScopesData",
    value: function getUserGatesPortalScopesData() {
      var _auth$get = auth.get(),
          user = _auth$get.user,
          gates = _auth$get.gates,
          portal = _auth$get.portal;

      return {
        user: user,
        allGates: gates,
        gates: this.getGatesMap(gates),
        portal: portal
      };
    }
  }, {
    key: "configureStore",
    value: function configureStore(routerHistory, initialState) {
      var usageTracker = getTracker();
      var middleware = [routerMiddleware(routerHistory), thunk, NotificationMiddleware, usageTrackerMiddleware(usageTracker, usageActionHandlers)].concat(_toConsumableArray(appMiddleware));
      return _configureStore(appRootReducer, initialState, middleware);
    }
  }, {
    key: "startReduxAndRouter",
    value: function startReduxAndRouter(withAuth) {
      var userGatesPortalScopesData = {
        user: {},
        allGates: [],
        gates: {},
        portal: {}
      };
      var basename = '/';

      if (withAuth) {
        userGatesPortalScopesData = this.getUserGatesPortalScopesData();
        basename = getBaseUrlForCustomers();
      }

      ContentRoutes.init(userGatesPortalScopesData.allGates);
      var routerHistory = useRouterHistory(createHistory)({
        basename: basename
      });
      this.store = this.configureStore(routerHistory, {
        auth: userGatesPortalScopesData
      });
      var history = syncHistoryWithStore(routerHistory, this.store);
      render(React.createElement(Provider, {
        store: this.store
      }, React.createElement(RhumbProvider, {
        history: historyAdapter(history),
        config: rhumbConfig
      }, React.createElement(Router, {
        history: history
      }, routes(this.store)))), document.getElementsByClassName('page')[0]);
    }
  }]);

  return Application;
}();

export { Application as default };